const boardPermissionLevels = {
  ':private': {
    label: 'Private',
    default: true
  },
  ':public': {
    label: 'Public'
  }
}

const invitationStatuses = {
  ':invitation/pending': {
    label: 'Pending',
    default: true
  },
  ':invitation/accepted': {
    label: 'Accepted'
  },
  ':invitation/rejected': {
    label: 'Rejected'
  }
}

const notificationStatuses = {
  ':unread': {
    label: 'Unread',
    default: true
  },
  ':acknowledged': {
    label: 'Acknowledged'
  }
}

const pollTypes = {
  ':before-votes': {
    label: 'Before voting',
    default: true
  },
  ':after-votes': {
    label: 'After voting'
  },
  ':after-closes': {
    label: 'After poll closes'
  },
  ':never-show': {
    label: 'Never'
  }
}

const pointEntityAttributes = {
  ':post-authored': {
    label: 'Post authored',
    default: true
  },
  ':comment-authored': {
    label: 'Comment authored'
  },
  ':comment-received': {
    label: 'Comment received'
  },
  ':any-reaction-received': {
    label: 'Any reaction received'
  },
  ':points-granted': {
    label: 'Points granted'
  },
  ':reaction-received': {
    label: 'Reaction received'
  }
}

const attachmentTypes = {
  ':file': {
    label: 'File',
    default: true
  },
  ':audio': {
    label: 'Audio'
  },
  ':doc': {
    label: 'Document'
  },
  ':img': {
    label: 'Image'
  },
  ':video': {
    label: 'Video'
  }
}

const notificationSettingTypes = {
  ':post': {
    label: 'Notify me when someone posts on a board I follow',
    default: true
  },
  ':reply': {
    label: 'Notify me when someone replies to my post'
  },
  ':comment-reply': {
    label: 'Notify me when someone replies to my comment'
  },
  ':reaction': {
    label: 'Notify me when someone reacts to my post'
  },
  ':mention': {
    label: 'Notify me when someone @mentions me in a post'
  },
  ':nudge': {
    label: 'Get automated reminder notifications'
  }
}

const copyBoardFromId = {
  ':null': {
    label: 'None',
    default: true
  }
}

const userPermissions = {
  ':cap-admin': 'Able to alter other users admin capabilities',
  ':contract-admin': 'Able to edit contract start + end dates',
  ':payment-admin': 'Able to edit student payment settings',
  ':tx-log': 'Guards the /admin/log api route',
  ':user-account-admin':
    'Ability to edit other user accounts for support needs',
  ':flag-admin': 'Able to access network features page'
}

const networkFeatures = {
  ':messages': 'Messages',
  ':hide-logout': 'Logout Options and User Password Functions',
  ':disable-email-edit': 'User Password Editing',
  ':identify-by-email': 'User Identifier is Email Address',
  ':bypass-lti-profile-setup': 'Bypass Profile Setup',
  ':freeform-points': 'Freeform Points',
  ':nudge-notify': 'Reminder Notifications',
  ':digest-notifications': 'Digest Notifications',
  ':post-anonymous': 'Anonymous posting',
  ':onboarding': 'Community Onboarding Flow',
  ':points-simplification': 'Points Simplification',
  ':lms-groups-integration': 'Group Setups from LMS (Canvas Only)',
  ':new-healthcheck': 'Optimized Community Health Dashboard',
  ':badges-widget': 'Accolade Widget',
  ':grade-snapshot': 'Grade Calculation - Only at End of Earning Periods',
  ':content-moderation': 'Enable AI driven auto moderator.',
  ':sso-share-links': 'SSO Share-Links',
  ':gdpr-compliance': 'Enable GDPR compliance features.',
  ':new-content-highlighting': 'New Content Highlighting',
  ':remove-help-widget': 'Hide Help Chatbot',
  ':freemium': 'Create a free community for a limited time'
}

const boardFeatures = {
  ':nudge-notify': 'Reminder Notifications',
  ':network-graph': 'User Graph Visualization',
  ':post-anonymous': 'Anonymous posting',
  ':onboarding': 'Community Onboarding',
  ':points-simplification': 'Points Simplification',
  ':slate-editor': 'New Post Editor'
}

const channels = {
  ':email': 'Email Notifications',
  ':in-app': 'In-app Notifications'
}

const paymentModes = {
  ':pay-per-board': { label: 'Pay For Each Community' },
  ':pay-per-network': { label: 'Pay Once For The Organization' },
  ':bookstore-payment-only': { label: 'Pay by Bookstore Codes Only' },
  ':payment-opt-out': {
    label: 'Remove payment requirement'
  }
}

const postVisibilityLevels = {
  ':public': { label: 'Public', default: true },
  ':anonymous': { label: 'Anonymous' }
}

const postFlagReportCategories = {
  ':inappropriate': { label: 'Inappropriate', default: true },
  ':offtopic': { label: 'Off Topic' },
  ':plagiarism': { label: 'Plagiarism' },
  ':worrisome': { label: 'Worrisome' },
  ':other': { label: 'Other' }
}

const boardGroupLmsProps = {
  ':board/group-context-ids': {
    label: 'Canvas Group Context IDs'
  },
  ':board/group-section-ids': {
    label: 'Canvas Section IDs'
  },
  ':board/group-name': {
    label: `Random Assignment (Yellowdig's Interface)`
  }
}

const networkDateFormat = {
  ':format1': 'DD/MM/YYYY HH:mm',
  ':format2': 'YYYY-MM-DD HH:mm'
}

module.exports = {
  ':board-settings/permission-level': boardPermissionLevels,
  ':board-settings/groups-from-lms-prop': boardGroupLmsProps,
  ':invitation/status': invitationStatuses,
  ':notification/status': notificationStatuses,
  ':poll/type': pollTypes,
  ':point-predicate/entity-attr': pointEntityAttributes,
  ':attachment/type': attachmentTypes,
  ':notification-setting/type': notificationSettingTypes,
  ':network/features': networkFeatures,
  ':user/admin-caps': userPermissions,
  ':board/features': boardFeatures,
  ':board/copy-content-from': copyBoardFromId,
  ':notification-setting/channels': channels,
  ':network-settings/enable-student-payment': paymentModes,
  ':payment-setting/enable-student-payment': paymentModes,
  ':post/visibility': postVisibilityLevels,
  ':post-flag/report-category': postFlagReportCategories,
  ':network-settings/date-format': networkDateFormat
}
